import $ from 'jquery';

import webApp from './webApp';

const stringsOfAllLanguages = {};

const i18n = {
  language: 'en',
  strings: {},
  _prevLanguage: null,

  init( language ) {
    this._prevLanguage = this.language = language;

    return this.setLanguage( language );
  },

  setLanguage( language ) {
    this._prevLanguage = this.language;

    const promise = ( stringsOfAllLanguages[ language ] )
      ? Promise.resolve( stringsOfAllLanguages[ language ] )
      : Promise.resolve( $.get( webApp.env.site_url +'/asmag/web-app/i18n-strings/'+ language ) );

    return promise.then( strings => {
      this.language = language;
      this.strings = stringsOfAllLanguages[ language ] = strings;
    } );
  },

  restorePreviousLanguage() {
    if ( this._prevLanguage && stringsOfAllLanguages[ this._prevLanguage ] ) {
      const language = this.language;

      this.language = this._prevLanguage;
      this.strings = stringsOfAllLanguages[ this._prevLanguage ];
      this._prevLanguage = language;

      return Promise.resolve( this.language );
    }
    else {
      return Promise.reject( 'No previous language to restore' );
    }
  },
};

export default i18n;
